<template>
  <div v-if="currentLeague" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>League Settings</h2>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <form @submit="saveLeague">
              <div class="form-group">
                <label for="name">League Name:</label>
                <input
                  required
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="settingsName"
                  value=""
                />
              </div>
              <div v-if="currentLeague.draft_status == 'Pending'" class="form-group">
                <label for="name">Draft Type:</label>
                <select
                  required
                  class="form-control"
                  name="draft_type"
                  v-model="settingsDraftType"
                >
                  <option disabled value="">Please select an option</option>
                  <option value="Auto">Auto</option>
                  <option value="Manual">Manual</option>
                </select>
                <div class="small text-muted">
                  Choose the type of draft this league will have.
                </div>
              </div>
              <div v-if="weeksLeftInYear.length > 0 && currentLeague.draft_status == 'Pending'" class="form-group">
                <!-- TODO: can not choose less than have already passed, if you're on week 4, can't choose a 3 week season" -->
                <label for="name">Season Length:</label>
                <select
                  required
                  class="form-control"
                  name="season_length"
                  v-model="settingsSeasonLength"
                >
                  <option disabled value="">Select number of weeks</option>
                  <option v-bind:value="8">8 weeks</option>
                  <option v-bind:value="12">12 weeks</option>
                  <option v-bind:value="16">16 weeks</option>
                  <option v-bind:value="20">20 weeks</option>
                  <option v-bind:value="24">24 weeks</option>
                </select>
                <div class="small text-muted">
                  Choose the number of weeks in your season. This determines how
                  long your season will last.
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Save</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Draft</h2>
        <!-- pending -->
        <div v-if="currentLeague.draft_status == 'Pending'">
          <p>
            The draft type you have chosen for this league is <strong>"{{ (currentLeague.draft_type == 'Manual')? 'Manual Draft' : 'Auto Draft' }}"</strong>.
          </p>
          <button @click="startDraft" class="btn btn-success" type="button" name="button">Start Draft</button>
        </div>
        <!-- in progress -->
        <div v-if="currentLeague.draft_status == 'In Progress'">
          <p>
            Your draft is in progress!
            <div  v-if="currentLeague.draft_type == 'Auto'" class="">
              If draft does not finish in a couple of minutes, refresh page or contact us for support.
            </div>
          </p>
          <router-link v-if="currentLeague.draft_type == 'Manual'" :to="{ name: 'Draft', params: {leagueId:$route.params.leagueId} }" class="btn btn-success">Enter Draft</router-link>
          <loader v-if="currentLeague.draft_type == 'Auto'" v-bind:embeded="true"></loader>
        </div>
        <!-- complete -->
        <div v-if="currentLeague.draft_status == 'Complete'">
          <p>
            The draft for this league is complete.
          </p>
        </div>
      </article>
    </div>

    <div class="col-12">
      <article class="fc-m-container">
        <h2>Teams</h2>
        <div class="table-responsive">
          <table class="table table-striped fc-m-league__table">
            <thead>
              <tr>
                <th></th>
                <th scope="col">Team name</th>
                <th scope="col">Owner</th>
              </tr>
            </thead>
            <tbody v-if="currentLeague.teams.length > 0">
              <tr v-for="t in currentLeague.teams" v-bind:key="t.id">
                <td class="">
                  <input type="checkbox" v-model="teams" v-bind:value="t.id" />
                </td>
                <td class="">
                  <router-link
                    :to="`/leagues/${currentLeague.id}/teams/${t.id}`"
                    class="fc-a-link--title"
                  >
                    {{ t.name }}
                  </router-link>
                </td>
                <td class="">
                  <div v-for="owner in t.owners" :key="owner.id">
                      {{ owner.username }}
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td></td>
                <td colspan="3">This league has no teams.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-4">
            <div class="form-group">
              <label for="name">Update Selected Teams:</label>
              <select
                required
                class="form-control"
                name="draft_type"
                v-model="teamsAction"
              >
                <option disabled value="">Please select an option</option>
                <option value="remove">Remove team(s)</option>
              </select>
            </div>
            <button
              @click="updateSelectedTeams"
              type="button"
              name="button"
              class="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </div>
        <div v-if="$store.state.auth.account_type == 'educator'" class="pt-5">
          <h2>Add Team</h2>
          <p>Create a team for yourself or a student.</p>
          <router-link class="btn btn-primary" :to="`/leagues/${currentLeague.id}/teams/create`">Create Team</router-link>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="fc-m-container">
        <h2>League Members</h2>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">Username</th>
                <th scope="col">Email</th>
                <th scope="col">Accepted?</th>
                <th scope="col">Commissioner?</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in currentLeague.players" v-bind:key="p.id">
                <td>
                  <input
                    type="checkbox"
                    v-model="members"
                    v-bind:value="p.user.id"
                  />
                </td>
                <td>{{ p.user.username }}</td>
                <td>{{ p.user.email }}</td>
                <td>
                  <div v-if="p.has_accepted">
                    X
                  </div>
                </td>
                <td>
                  <div v-if="p.is_commissioner">
                    X
                  </div>
                </td>
              </tr>
              <tr v-for="p in getPendingAccounts(currentLeague.pending_accounts)" v-bind:key="p">
                <td>
                  <input
                    type="checkbox"
                    v-model="pending_accounts"
                    v-bind:value="p"
                  />
                </td>
                <td>n/a</td>
                <td>{{ p }}</td>
                <td>
                </td>
                <td>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-4">
            <div class="form-group">
              <label for="name">Update Selected Members:</label>
              <select
                required
                class="form-control"
                name="draft_type"
                v-model="membersAction"
              >
                <option disabled value="">Please select an option</option>
                <option value="remove">Remove user(s)</option>
              </select>
            </div>
            <button
              @click="updateSelectedMembers"
              type="button"
              name="button"
              class="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </div>

        <h2 class="pt-5">Add Players</h2>
        <div v-if="$store.state.auth.account_type == 'educator'">
          <div class="form-group">
            <label for="players">Select Players:</label>
            <select v-model="selectedPlayers" multiple class="form-control" id="players" name="players">
              <option v-for="player in availablePlayers" :key="player.id" :value="player.id">{{player.username}}</option>
            </select>
            <p class="small d-none d-md-inline-block">Hold <code>Ctrl</code> while clicking to make multiple selections.</p>
          </div>
          <button class="btn btn-primary" @click="addStudents">
            Submit
          </button>
        </div>
        <div v-else>
          <div class="form-group">
            <label for="invitees"
              >Invite friends to play in your league by entering their email
              separated by commas.</label
            >
            <textarea
              name="invitees"
              class="form-control"
              v-model="invitees"
            ></textarea>
          </div>
          <button @click="sendInvites" type="submit" class="btn btn-primary">
            Submit
          </button>
        </div>

      </article>
    </div>
    <div v-if="$store.state.auth.account_type == 'educator'" class="col-12 ">
        <article class="fc-m-container">
          <h2>League Passphrase</h2>
          <p> Students that register with this passphrase on your sign up page will automatically
            be added to this league. Get the url for your sign up page <a href="/students">here</a>.
          </p>
          <div v-if="passphrase" >
            <div class="">
              Passphrase:
            </div>
            <p class="alert alert-success">
              <b>{{ passphrase }}</b>
            </p>
          </div>
          <form class="" @submit="updatePassphrase">
            <div class="form-group col-12 col-md-6">
              <label for="passphrase">{{ (passphrase) ? "Update Passphrase:" :"Create Passphrase:"}}</label>
              <input v-model="updatedPassphrase" type="text" class="form-control" name="passphrase" value="">
              <p class="small">Enter a new passphrase for this league. Minimum of 10 characters. Only alphanumeric and special characters !, @, #, $, and % are allowed.</p>
            </div>
            <button type="submit" class="btn btn-primary" name="button">Submit</button>
          </form>
        </article>
    </div>
    <div class="col-12">
      <article class="alert alert-danger">
        <h2>Delete League</h2>
        <p class="">
          All teams and data associated with this league will be removed. You
          can not undo this action.
        </p>
        <button
          @click="deleteLeague(currentLeague)"
          class="btn btn-danger"
          type="button"
          name="button"
        >
          Delete League
        </button>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";
import { handleErrors } from "@/utils/errors.js";

export default {
  name: "LeaguesEdit",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      currentLeague: null,
      settingsName: "",
      settingsDraftType: "",
      settingsSeasonLength: "",
      members: [],
      membersAction: "",
      invitees: "",
      teams: [],
      teamsAction: "",
      draftStarted: false,
      pending_accounts: [],
      updatedPassphrase: '',
      passphrase: null,
      availablePlayers: [],
      selectedPlayers: [],
    };
  },
  created: function() {
    this.getLeague();
  },
  methods: {
    addStudents: function(e){
      e.preventDefault()
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({});

      for (let i = 0; i < app.selectedPlayers.length; i++) {
        form.append("users", app.selectedPlayers[i]);
      }

      fetch(`${process.env.VUE_APP_PLATFORM}/api/leagues/${app.$route.params.leagueId}/`, {
        credentials: "include",
        method: "PATCH",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      })
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
            app.getLeague();
            app.selectedPlayers = []
            app.$store.commit("alert/addMessage", {
              message: `New students added!`,
              class: "success",
              persist: false
            });
        }).catch(function(e){
          app.$store.commit("alert/addMessage", {
            message: `Could not add students to league.`,
            class: "danger",
            persist: false
          });
        });


    },
    getStudents: function(){
      let app = this;

      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/?limit=200`;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          let leaguePlayers = app.currentLeague.players.map(p => p.user.id)
          app.availablePlayers = response.results.filter(s => !leaguePlayers.includes(s.id)).sort((a, b) => a.username.localeCompare(b.username))
        }).catch(function(e){
          app.$store.commit("alert/addMessage", {
            message: `Unable to get students. Please refresh and try again.`,
            class: "warning",
            persist: false
          });
        });
    },
    updatePassphrase: function(e){
      e.preventDefault()
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let passphrase = new URLSearchParams({
        passphrase: app.updatedPassphrase
      });

      let status;

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/update-passphrase/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: passphrase,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        status = response.status
        return response.json()
      }).then(function(response) {
        if (status == 200){
          app.passphrase = response.misc.passphrase
          app.updatedPassphrase = '';
          app.$store.commit("alert/addMessage", {
            message: `Your passphrase was updated.`,
            class: "success",
            persist: false
          });
        } else {
          handleErrors(response.errors )
        }
      })
    },
    getPendingAccounts: function(accounts){
      return accounts.filter(a=> a != '');
    },
    handleErrors: function(errors) {
      let app = this;
      let errorFields = Object.keys(errors);
      for (let i = 0; i < errorFields.length; i++) {
        if (typeof errors[errorFields[i]] == 'object'){
          errors[errorFields[i]] = [errors[errorFields[i]][0]]
        }
        for (let x = 0; x < errors[errorFields[i]].length; x++) {
          let field = errorFields[i];
          app.$store.commit("alert/addMessage", {
            message: `${field}: ${errors[errorFields[i]][x]}`,
            class: "danger",
            persist: false
          });
        }
      }
    },
    clearFields: function() {
      this.members = [];
      this.membersAction = "";
      this.invitees = "";
      this.teams = [];
      this.teamsAction = "";
    },
    deleteLeague: function(league) {
      const csrftoken = getCookie("csrftoken");
      let app = this;
      fetch(process.env.VUE_APP_PLATFORM + "/api/leagues/" + league.id + "/", {
        credentials: "include",
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      }).then(function(response) {
        if (response.status == 204 || response.status == 200) {
          app.$router.push("/leagues");
          app.$store.commit("alert/addMessage", {
            message: `You deleted the league "${league.name}"`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: "Whoops something went wrong. Unable to delete league.",
            class: "danger",
            persist: false
          });
        }
      });
    },
    getLeague: function() {
      let app = this;
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          let is_commish = response.players.filter(player=>player.is_commissioner == true && player.user.id == app.$store.state.auth.user_id)
          if ( is_commish.length > 0){
            app.$store.commit("breadcrumb/updateDynamicLinks", {
              dynamic_links: [
                {
                  static_name: ":league",
                  dynamic_name: response.name,
                  url: `/leagues/${response.id}`
                }
              ]
            });
            app.$store.commit("breadcrumb/display");
            app.settingsName = response.name;
            app.settingsDraftType = response.draft_type;
            app.settingsSeasonLength = response.season_length;
            app.clearFields();
            app.passphrase = (Object.keys(response.misc).includes('passphrase')) ? response.misc.passphrase : null;
            app.currentLeague = response;
            // get students
            if(app.$store.state.auth.account_type == 'educator'){
              app.getStudents()
            }
          }
        });
    },
    removePlayers: function(ids) {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({})

      for (let i = 0; i < ids.length; i++) {
        form.append("users", ids[i]);
      }

      return fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/users/remove/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.ok){
          return response.json();
        } else {
          return Promise.reject();
        }
      }).catch(function(e){
            app.$store.commit("alert/addMessage", {
              message: `Could not remove existing player from league.`,
              class: "danger",
              persist: false
            });
      })
    },
    removePendingPlayers: function(emails){
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({})
      for (let i = 0; i < emails.length; i++) {
        form.append("remove_invitees", emails[i]);
      }

      return fetch(`${process.env.VUE_APP_PLATFORM}/api/leagues/${
        app.$route.params.leagueId
      }/`, {
        credentials: "include",
        method: "PATCH",
        mode: "cors",
        body: form,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      }).then(function(response) {
        if (response.ok){
          return response.json()
        } else {
          return Promise.reject()
        }

      }).catch(function(e){
          app.$store.commit("alert/addMessage", {
            message: `Could not remove invited player.`,
            class: "danger",
            persist: false
          });
      })
    },
    removeTeam: function(id) {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/teams/${id}/`,
        {
          credentials: "include",
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200 || response.status == 204) {
          app.currentLeague = null;
          app.getLeague();
          app.$store.commit("alert/addMessage", {
            message: `Removed team from league!`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: `Unable to remove team from league.`,
            class: "danger",
            persist: false
          });
        }
      });
    },
    saveLeague: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        name: app.settingsName,
        draft_type: app.settingsDraftType,
        season_length: app.settingsSeasonLength
      });
      let status = 0;
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        status = response.status
        return response.json()
      }).then(function(response){
        if (status == 200) {
          app.$router.go(0)
          app.$store.commit("alert/addMessage", {
            message: `Changes saved to league!`,
            class: "success",
            persist: false
          });
        } else {
          app.handleErrors(response)
        }
      });
    },
    sendInvites: function() {
      let app = this;
      if (app.invitees.length > 0) {
        const csrftoken = getCookie("csrftoken");
        let form = new URLSearchParams({});
        let invitees_list = app.invitees == "" ? [] : app.invitees.trim().split(",");
        let invitees_cleaned = invitees_list.filter(email=> email != '')

        for (let i = 0; i < invitees_cleaned.length; i++) {
          form.append("invitees", invitees_cleaned[i]);
        }

        fetch(
          `${process.env.VUE_APP_PLATFORM}/api/leagues/${
            app.$route.params.leagueId
          }/invite/`,
          {
            credentials: "include",
            method: "POST",
            mode: "cors",
            body: form,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "X-CSRFToken": csrftoken
            }
          }
        ).then(function(response) {
          if (response.status == 200) {
            app.currentLeague = null;
            app.getLeague();
            app.$store.commit("alert/addMessage", {
              message: `New players invited to league!`,
              class: "success",
              persist: false
            });
            return {}
          } else {
            return response.json()
          }
        }).then(function(response){
          if(response != {}){
            handleErrors(response)
          }
        });
      }
    },
    startDraft: function() {
      let app = this;
      if(app.currentLeague.teams.length > 1){
        if(app.currentLeague.draft_type == 'Manual'){
          app.startManualDraft()
        } else {
          app.startAutoDraft()
        }
      } else {
        app.$store.commit("alert/addMessage", {
          message: `League must have at least two teams to draft.`,
          class: "danger",
          persist: false
        });
      }

    },
    startManualDraft: function(){
      // update draft status of league to in progress
      // route to manual draft page
      let app = this;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        draft_status: 'In Progress',
      });

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response){
        if(response.status == 200){
          app.$router.push(`/leagues/${app.$route.params.leagueId}/draft`)
        }
      })
    },
    startAutoDraft:function(){
      let app = this;
      app.currentLeague.draft_status = 'In Progress'
      const csrftoken = getCookie("csrftoken");

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/draft/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.$router.push(`/leagues/${app.$route.params.leagueId}/`)
          app.$store.commit("alert/addMessage", {
            message: "Draft is complete! The season for this league has begun.",
            class: "success",
            persist: false
          });

        } else {
          app.$store.commit("alert/addMessage", {
            message: "Something went wrong. Unable to complete draft",
            class: "danger",
            persist: false
          });
        }
      });
    },
    updateSelectedMembers: function() {
      let app = this;

      if (app.membersAction == "remove") {
        if (app.members.length && app.pending_accounts.length){
          app.removePlayers(app.members).then(function(response){
              app.removePendingPlayers(app.pending_accounts).then(function(){
                app.currentLeague = null;
                app.getLeague();
                app.$store.commit("alert/addMessage", {
                  message: `League players updated.`,
                  class: "success",
                  persist: false
                });
              })
          })
        } else if (app.members.length) {
          app.removePlayers(app.members).then(function(response){
              app.currentLeague = null;
              app.getLeague();
              app.$store.commit("alert/addMessage", {
                message: `League players updated.`,
                class: "success",
                persist: false
              });
          })
        } else if (app.pending_accounts.length){
          app.removePendingPlayers(app.pending_accounts).then(function(){
            app.currentLeague = null;
            app.getLeague();
            app.$store.commit("alert/addMessage", {
              message: `League players updated.`,
              class: "success",
              persist: false
            });
          })
        } else {
          app.$store.commit("alert/addMessage", {
            message: `No players selected.`,
            class: "warning",
            persist: false
          });
        }
      }

    },
    updateSelectedTeams: function() {
      let app = this;
      if (app.teamsAction == "remove") {
        for (let i = 0; i < app.teams.length; i++) {
          app.removeTeam(app.teams[i]);
          //TODO: Dont show alerts until all teams are done updating
        }
      }
    }
  },
  computed: {
    sortedTeams: function() {
      let toSort = [].concat(this.currentLeague.team);
      return toSort.sort((a, b) => {
        return b.total_points - a.total_points;
      });
    },
    weeksLeftInYear: function() {
      //TODO: move to momentjs
      let currentDate = new Date();
      let increment = 7 - currentDate.getDay();
      let nextSunday = currentDate.getTime() + 86400000 * increment;
      let dec31 = new Date(currentDate.getFullYear(), 11, 31);
      let dec31MS = dec31.getTime();
      let timeTilEOY = dec31MS - nextSunday;
      let weeks = parseInt(timeTilEOY / (86400000 * 7)) - 2;
      return weeks > 0 ? Array.from(Array(weeks).keys()) : [];
    }
  }
};
</script>

<style lang="scss">
table.fc-m-league__table td {
  vertical-align: top;
}
</style>
